import SlashIcon from "@redotech/redo-icons/slash-octagon_filled.svg";
import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { doNothingFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  DoNothingState,
  isDoNothingStepValid,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const DO_NOTHING = (
  Details: React.ComponentType<StepTypeDetailsProps<DoNothingState>>,
): StepType<DoNothingState, ModelStep.DoNothing> => ({
  Details: (props: StepTypeDetailsProps<DoNothingState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return "Do nothing";
  },
  title: "Do nothing",
  valid(state) {
    return isDoNothingStepValid(state).valid;
  },
  Icon: SlashIcon,
  description(state) {
    return "Do nothing";
  },
  empty: {},
  downstream(state) {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {});
  },
  layout() {
    return BlockLayout.FULL;
  },
  toModel(state, id) {
    return { type: ModelStep.DO_NOTHING };
  },
  fromModel(model) {
    return doNothingFromModel(model);
  },
});

export { type DoNothingState } from "@redotech/redo-model/return-flow-step-valid";
